import { CalendarDaysIcon, NewspaperIcon } from "@heroicons/react/24/outline";

export default function routes(pathname, user_type) {
  var title;
  var routes;

  const isCFIA = user_type === 4;

  routes = [
    {
      name: "Schedule",
      href: "/schedule",
      icon: CalendarDaysIcon,
      current: false,
      showInMenu: !isCFIA,
    },
    {
      name: "Work Orders",
      icon: NewspaperIcon,
      current: false,
      showInMenu: !isCFIA,
      open: false,
      children: [
        {
          name: "Create",
          href: "/new-work-order",
          current: false,
        },
        { name: "Manage Orders", href: "/work-orders", current: false },
      ],
    },
  ];

  routes.forEach((route) => {
    route.open = false;
    if (route.children) {
      route.children.forEach((child) => {
        child.current = false;
        if (child.href === pathname) {
          route.open = true;
          child.current = true;

          title = child.name;
        }
      });
    } else if (route.href === pathname) {
      route.current = true;

      title = route.name;
    }
  });

  var returnArray = {
    routes: routes.filter((route) => route.showInMenu),

    title: title,
  };

  return returnArray;
}
